import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  outOfStock,
  cartError,
  productError,
  otherError,
  viewBasket,
  continueShopping,
  productMisconfiguration
} = translate({
  "outOfStock": "Product out of stock",
  "cartError": "The cart is no longer available",
  "productError": "The product is no longer available",
  "otherError": "An error has occurred",
  "viewBasket": "View basket",
  "continueShopping": "Continue shopping",
  "productMisconfiguration": "Ah, there's been a little error - the product has not successfully been added to your basket"
});
export const title = translateFormatter<{
  productsNumber: number;
}>([{
  "type": 6,
  "value": "productsNumber",
  "options": {
    "=0": {
      "value": [{
        "type": 0,
        "value": "No products could be added"
      }]
    },
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 product has been added"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " products have been added"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const titleLonger = translateFormatter<{
  productsNumber: number;
}>([{
  "type": 6,
  "value": "productsNumber",
  "options": {
    "=0": {
      "value": [{
        "type": 0,
        "value": "No products could be added to your basket"
      }]
    },
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 product added to your basket"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " products added to your basket"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");